import { render } from "./MessagesText.vue?vue&type=template&id=4fbb6dfa"
import script from "./MessagesText.vue?vue&type=script&lang=js"
export * from "./MessagesText.vue?vue&type=script&lang=js"

import "./MessagesText.vue?vue&type=style&index=0&id=4fbb6dfa&lang=css"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__